// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import axios from 'axios';
// import BaiduMap from 'vue-baidu-map'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI)
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import TopHead from "./components/topHead.vue";
Vue.component("TopHead", TopHead);
import TopSearch from "./components/topSearch.vue";
Vue.component("TopSearch", TopSearch);
import Breadcrumb from "./components/Breadcrumb.vue";
Vue.component("Breadcrumb", Breadcrumb);
import OldTopHead from "./components/oldTopHead.vue";
Vue.component("OldTopHead", OldTopHead);
import Footer from "./components/Footer.vue";
Vue.component("Footer", Footer);
// Vue.use(BaiduMap, {
//   ak: '2lMRUPS4A1g1cHniwuHks0s1eUPnkew4'
// })
Vue.config.productionTip = false
// axios.defaults.baseURL='https://www.motortime.com/'
axios.defaults.withCredentials = true
axios.defaults.timeout = 1000 * 15
window.axios = axios;
axios.interceptors.response.use(response => {
  if(!response.data.state) {
    // Toast(response.data.error.join('，'))
  }
  return response
}, error => {
  switch (error.response.status) {
    case 500:
    this.$Message.info('服务器内部错误');
    // Toast('服务器内部错误')
    break;
    case 401:
    this.$Message.info('登录失效，请重新登录');
    // Toast('登录失效，请重新登录')
    break;
    case 403:
    this.$Message.info('禁止访问');
    // Toast('禁止访问')
    break;
  }
  return Promise.reject(error);
})
// 全局配置
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if(to.meta.keywords){
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description)
  }
  if (_hmt) {
    if (to.path) {
     _hmt.push(['_trackPageview', '/#' + to.fullPath]);
   }
 }
  // next()
 if(to.matched.length==0){
  window.open('https://www.motortime.com/404', '_self');
}else{
  next()
}

})
if(localStorage.getItem('pc_token')) {
  store.dispatch('param/setToken', localStorage.getItem('pc_token'))
}
router.afterEach((to, from, next) => {
  store.commit('param/position', {
    name: from.path,
    position: document.body.scrollTop || document.documentElement.scrollTop
  })

  if (store.state.param.positions && store.state.param.positions[to.path]) {
    setTimeout(() => {
      window.scrollTo(0, store.state.param.positions[to.path])
    }, 1)
  } else {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 1)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js